import { createFileRoute, redirect } from "@tanstack/react-router";

/** Retired duplicate browsing experience. Articles is the canonical archive. */
export const Route = createFileRoute("/feed")({
  beforeLoad: () => {
    throw redirect({ to: "/discoveries", statusCode: 301 });
  },
  component: () => null,
});
